// Web shim for @react-native-firebase/firestore
// Uses firebase/compat which has the same chained API as @react-native-firebase.
import firebase from '../../config/firebase.web';

const firestore = () => firebase.firestore();

// Re-export FieldValue for callers that use firestore.FieldValue
firestore.FieldValue = firebase.firestore.FieldValue;
firestore.Timestamp = firebase.firestore.Timestamp;

export default firestore;
